"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KlassInfo = void 0;
const react_1 = __importDefault(require("react"));
const klass_1 = require("../klass");
exports.KlassInfo = react_1.default.memo(({ id, classId, setClassId, }) => {
    return (react_1.default.createElement("div", { className: "admin-detail-info" },
        react_1.default.createElement("div", { className: "admin-title" },
            react_1.default.createElement("div", { className: "admin-title-left" },
                react_1.default.createElement("p", null, "\uD074\uB798\uC2A4 \uC815\uBCF4"))),
        react_1.default.createElement(klass_1.KlassList, { onlyOne: true, searchOption: "", initPage: 0, defaultProps: { belong_any: id }, classId: classId, setClassId: setClassId })));
});
